import {
  IconoLogistica, IconoConversaciones, IconoLeads, IconoAvisos, IconoAgendamiento, IconoCalendario, IconoConfirmar, IconoRecalculo, IconoIncidencias, IconoAuditoria, IconoGE,
  IconoLogisticaSolido, IconoConversacionesSolido, IconoLeadsSolido, IconoAvisosSolido,
  IconoAgendamientoSolido, IconoCalendarioSolido, IconoConfirmarSolido, IconoRecalculoSolido, IconoIncidenciasSolido, IconoAuditoriaSolido, IconoGESolido,
} from './iconos'

export interface Destino {
  ruta: string
  etiqueta: string
  /**
   * El rotulo de la barra inferior de movil.
   *
   * Con cinco destinos, a 375 px cada celda mide 75 px (71 utiles descontando
   * el `px-1`) y a 11 px no entra un rotulo de mas de diez caracteres:
   * "Conversaciones" mide 14 y saldria recortado. Recortar el texto de un
   * destino de navegacion es peor que acortarlo a proposito, porque nadie
   * elige que se pierde. La barra lateral de escritorio sigue usando
   * `etiqueta`, que es la larga.
   */
  etiquetaMovil: string
  Icono: React.ComponentType<{ className?: string }>
  IconoActivo: React.ComponentType<{ className?: string }>
}

export const DESTINOS: Destino[] = [
  { ruta: '/logistica', etiqueta: 'Logistica', etiquetaMovil: 'Logistica', Icono: IconoLogistica, IconoActivo: IconoLogisticaSolido },
  { ruta: '/conversaciones/clientes', etiqueta: 'Conversaciones', etiquetaMovil: 'Mensajes', Icono: IconoConversaciones, IconoActivo: IconoConversacionesSolido },
  { ruta: '/conversaciones/leads', etiqueta: 'Leads', etiquetaMovil: 'Leads', Icono: IconoLeads, IconoActivo: IconoLeadsSolido },
  { ruta: '/avisos', etiqueta: 'Avisos', etiquetaMovil: 'Avisos', Icono: IconoAvisos, IconoActivo: IconoAvisosSolido },
  { ruta: '/confirmar', etiqueta: 'Confirmar', etiquetaMovil: 'Confirmar', Icono: IconoConfirmar, IconoActivo: IconoConfirmarSolido },
  { ruta: '/incidencias', etiqueta: 'Incidencias', etiquetaMovil: 'Incid.', Icono: IconoIncidencias, IconoActivo: IconoIncidenciasSolido },
  { ruta: '/agendamiento', etiqueta: 'Agendamiento', etiquetaMovil: 'Agenda', Icono: IconoAgendamiento, IconoActivo: IconoAgendamientoSolido },
  { ruta: '/grandes-empresas', etiqueta: 'Grandes Empresas', etiquetaMovil: 'GE', Icono: IconoGE, IconoActivo: IconoGESolido },
  { ruta: '/calendario', etiqueta: 'Calendario', etiquetaMovil: 'Calend.', Icono: IconoCalendario, IconoActivo: IconoCalendarioSolido },
  { ruta: '/auditoria', etiqueta: 'Auditoría', etiquetaMovil: 'Audit.', Icono: IconoAuditoria, IconoActivo: IconoAuditoriaSolido },
  { ruta: '/recalculo', etiqueta: 'Recálculo', etiquetaMovil: 'Recálculo', Icono: IconoRecalculo, IconoActivo: IconoRecalculoSolido },
]
